// Opens the browser's native picker UI for a date/time input; falls back to
// focusing the input in browsers without showPicker support.
export function openNativeTimePicker(input: HTMLInputElement): void {
  const nativeInput = input as HTMLInputElement & { showPicker?: () => void };
  if (typeof nativeInput.showPicker === 'function') {
    nativeInput.showPicker();
  } else {
    input.focus();
  }
}
